import burger from './modules/burger';
import carousel from './modules/carousel';
import news from './modules/news';
import popup from './modules/popup';
import contact from './modules/contact';
import lang from './modules/lang';
import signup from './modules/signup';
import tabs from './modules/tabs';
import dropdown from './modules/dropdown';
// import sort from './modules/sort';
import showMore from './modules/showMore';
import scrollTop from './modules/scrollTop';
import sortTable from './modules/sortTable';
// import accordionTable from './modules/accordionTable';

// Pollyfils

// NodeList foreach
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
    Element.prototype.closest = function (s) {
        var el = this;

        do {
            if (el.matches(s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}


carousel({
    selector: '#carousel-partners',
    loop: true,
});

carousel({
    selector: '#carousel-sites',
    loop: true,
});

carousel({
    selector: '#carousel-publishers',
    perPage: {
        768: 3,
        1024: 3,
        1180: 4,
    },
    loop: true,
});

if (window.innerWidth < 768) {
    carousel({
        selector: '#carousel-publishers2',
        perPage: {
            768: 3,
            1024: 3,
            1180: 4,
        },
        loop: true,
    });
}

carousel({
    selector: '#carousel-advertisers',
    perPage: {
        768: 3,
        1024: 3,
        1180: 4,
    },
    loop: true,
});

carousel({
    selector: '#carousel-payments',
    loop: true,
});

carousel({
    selector: '#carousel-news',
    perPage: {
        768: 1,
        1024: 2,
        1180: 2,
    },
    loop: true,
});

if (window.innerWidth < 768) {
    carousel({
        selector: '#carousel-benefit',
        perPage: {
            0: 1,
        },
        loop: true,
    });
}

(function () {
    var items = document.querySelectorAll('.nav-dropdown__name');
    items.forEach(el => {
        el.addEventListener('click', toggle);

    });

    function toggle(e) {
        e.preventDefault();
        this.parentElement.classList.toggle('nav-dropdown--open');
        window.addEventListener('click', closeNav);
    }

    function closeNav(e) {
        // download pollyfil here https://gomakethings.com/detecting-clicks-outside-of-an-element-with-vanilla-javascript/
        if (e.target.closest('.nav-dropdown')) return;


        items.forEach(el => {
            el.parentElement.classList.remove('nav-dropdown--open');
            window.removeEventListener('click', closeNav)
        });
    }
})()



window.tools = {
    fix: function () {
        document.body.classList.toggle('body--fix');
    }
}


var imgObj = document.getElementById('js-image');

function gray(imgObj) {

    return;
    var canvas = document.createElement('canvas');
    var canvasContext = canvas.getContext('2d');

    var imgW = 600;
    var imgH = 400;
    canvas.width = imgW;
    canvas.height = imgH;

    canvasContext.drawImage(imgObj, 0, 0);
    var imgPixels = canvasContext.getImageData(0, 0, imgW, imgH);

    for (var y = 0; y < imgPixels.height; y++) {
        for (var x = 0; x < imgPixels.width; x++) {
            var i = (y * 4) * imgPixels.width + x * 4;
            var avg = (imgPixels.data[i] + imgPixels.data[i + 1] + imgPixels.data[i + 2]) / 3;
            imgPixels.data[i] = avg;
            imgPixels.data[i + 1] = avg;
            imgPixels.data[i + 2] = avg;
        }
    }
    canvasContext.putImageData(imgPixels, 0, 0, 0, 0, imgPixels.width, imgPixels.height);
    return canvas.toDataURL();
}
//imgObj.src = gray(imgObj);

// Grayscale Images fix for IE10-IE11
var GrayScaleFix = (function () {

    return;
    var needToFix = /(MSIE 10)|(Trident.*rv:11\.0)|( Edge\/[\d\.]+$)/.test(navigator.userAgent);

    console.log(312312312);


    function replaceImage(image) {
        var tmpImage = new Image();
        tmpImage.onload = function () {
            var imgWrapper = document.createElement('span'),
                svgTemplate =
                '<svg xmlns="http://www.w3.org/2000/svg" id="svgroot" viewBox="0 0 ' + tmpImage.width + ' ' + tmpImage.height + '" width="100%" height="100%">' +
                '<defs>' +
                '<filter id="gray">' +
                '<feColorMatrix type="matrix" values="0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0" />' +
                '</filter>' +
                '</defs>' +
                '<image filter="url(&quot;#gray&quot;)" x="0" y="0" width="' + tmpImage.width + '" height="' + tmpImage.height + '" preserveAspectRatio="none" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + tmpImage.src + '" />' +
                '</svg>';

            imgWrapper.innerHTML = svgTemplate;
            imgWrapper.className = 'grayscale-fix';
            image.parentNode.insertBefore(imgWrapper, image);

            image.style.cssText += 'visibility:hidden;display:block';
            imgWrapper.querySelector('svg').style.position = 'absolute';
            imgWrapper.style.cssText = 'display:inline-block;position:relative;';
            imgWrapper.appendChild(image);
        };
        tmpImage.src = image.src;
    }

    function replaceAll() {
        var images = document.querySelectorAll('.carousel__item img');
        console.log(images);

        for (var i = 0; i < images.length; i++) {
            replaceImage(images[i]);
        }
    }

    if (needToFix) {
        document.addEventListener('DOMContentLoaded', replaceAll);
    }

    return {
        replace: replaceImage,
        refresh: replaceAll
    };
}());

// export function scrollToContacts() {
//     alert('asasa');
// }

// window.addEventListener('scroll', function (e) {
//     // var pathname = window.location.pathname;
//     var header = document.querySelector('.header');

//     // if (pathname !== '/') {
//     //     return
//     // }

//     if (window.pageYOffset > header.offsetTop) {
//         header.classList.add("header--sticky");
//     } else {
//         header.classList.remove("header--sticky");
//     }
// });

window.addEventListener('DOMContentLoaded', function(){
    contact();
})

if (screen.width > 768) {
    var videoHtml = '<video autoplay muted loop id="background-video"><source src="/home/Planetv2.mp4"  type="video/mp4"></video>'
    if (document.getElementById('video-container')) {
        document.getElementById('video-container').innerHTML = videoHtml;
    }
}


// const mySiema = new Siema({
//   selector: '#carousel-partners',
//   perPage: {
//     768: 3,
//     1024: 3,
//     1180: 4,
//     1300: 5
//   }
// });
